import { CopyOutlined } from '@ant-design/icons';
import { Input, FormProps, Button } from 'antd';
import { useTranslation } from 'react-i18next';

import Form from './Form';

export interface MindsightKeyPairFormValues {
  clientId: string;
  publicKey: string;
}

const MindsightKeyPairForm = (props: FormProps) => {
  const { t } = useTranslation();

  const publicKeyValue = Form.useWatch('publicKey', props.form);

  return (
    <Form<MindsightKeyPairFormValues> {...props}>
      <Form.Item label="Client ID" name="clientId">
        <Input />
      </Form.Item>
      <Form.Item label={t('Chave pública')} name="publicKey">
        <Input.TextArea disabled rows={9} style={{ fontFamily: 'monospace' }} />
      </Form.Item>
      <Button
        ghost
        icon={<CopyOutlined />}
        type="primary"
        onClick={async () => {
          await navigator.clipboard.writeText(publicKeyValue);
        }}
      >
        {' '}
        {t('Copiar')}
      </Button>
    </Form>
  );
};

export default MindsightKeyPairForm;
